import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"border":"none","padding":"0","margin":"0"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("legend", { class: "sr-only" }, "Filter statistics by prisoner status", -1)

import GraphComponent from "@/components/visualisation/GraphComponent.vue";
import NumbersComponent from "@/components/visualisation/NumbersComponent.vue";
import StateMapComponent from "@/components/visualisation/StateMapComponent.vue";
import {computed, ref} from "vue";
import {useFilter} from "@/composables/useFilter";
import useAirtable from "@/composables/useAirtable";

export default /*#__PURE__*/_defineComponent({
  __name: 'VisualisationComponent',
  async setup(__props) {

let __temp: any, __restore: any

const {checkPrisonerFilter} = useFilter()
const { records, fetchRecords } = useAirtable('stats');
;(
  ([__temp,__restore] = _withAsyncContext(() => fetchRecords())),
  await __temp,
  __restore()
);

// Empty string is the "All Cases" option: checkPrisonerFilter treats a blank
// filter as no filter. The homepage statistics open on the whole archive
// rather than on the currently-held subset — the charts below are a portrait
// of who has been imprisoned, and defaulting to "In Custody or Exiled" made
// them read as a portrait of who is imprisoned today, which is a much smaller
// and differently-shaped group. The database page has its own filters and is
// unaffected; this component only ever mounts on #app-stats, on the homepage.
const buttonFilter = ref<string>('')

// Computed property to generate filtered records
const filteredRecords = computed(() => {
  return records.value.filter((record) => {
    return checkPrisonerFilter(record, buttonFilter)
  });
});


return (_ctx: any,_cache: any) => {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("nav", null, [
      _createElementVNode("fieldset", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_a_radio_group, {
          value: buttonFilter.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((buttonFilter).value = $event)),
          class: "visualisation-filter-cnt"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_button, { value: "imprisonedOrExiled" }, {
              default: _withCtx(() => [
                _createTextVNode("In Custody or Exiled")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "" }, {
              default: _withCtx(() => [
                _createTextVNode("All Cases")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "inExile" }, {
              default: _withCtx(() => [
                _createTextVNode("In Exile")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "inCustody" }, {
              default: _withCtx(() => [
                _createTextVNode("In Custody")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "released" }, {
              default: _withCtx(() => [
                _createTextVNode("Released")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "awaitingTrial" }, {
              default: _withCtx(() => [
                _createTextVNode("Awaiting Trial")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        _createVNode(GraphComponent, { records: filteredRecords.value }, null, 8, ["records"])
      ]),
      _: 1
    })),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        _createVNode(NumbersComponent, { records: filteredRecords.value }, null, 8, ["records"])
      ]),
      _: 1
    })),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        _createVNode(StateMapComponent, { records: filteredRecords.value }, null, 8, ["records"])
      ]),
      _: 1
    }))
  ]))
}
}

})